
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/hi/video",
      function () {
        return require("private-next-pages/hi/video.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/hi/video"])
      });
    }
  